import { Link } from "react-router";
import { Box, Button, Stack, Typography } from "@mui/material";

import { usePageTitle } from "@/hooks/use-page-title";
import { paths } from "@/paths";

const NotFound = () => {
  usePageTitle("Page not found");

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "background.default",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 3,
      }}
    >
      <Stack spacing={2} sx={{ alignItems: "center" }}>
        <Typography variant="h2" sx={{ fontWeight: 700 }}>
          404
        </Typography>
        <Typography color="text.secondary">Oops! Looks like this trail leads nowhere.</Typography>
        <Stack direction="row" spacing={1.5}>
          <Button component={Link} to="/" variant="contained">Go Home</Button>
          <Button component={Link} to={paths.studio} variant="outlined">Studio</Button>
        </Stack>
      </Stack>
    </Box>
  );
};

export default NotFound;
